export const PURCHASE_TYPE = {
  STORE: "STORE",
  DELIVERY: "DELIVERY",
};
